<mat-table [class]="transportKind() === OfferTransportKind.PLANE ? 'plane' : 'couch'" [dataSource]="dataSource">
	<ng-container matColumnDef="city">
		<mat-header-cell *matHeaderCellDef>Miasto</mat-header-cell>
		<mat-cell *matCellDef="let element">
			<strong
				><span [appBoardingStatus]="element.action" [locationName]="element.stop.location.name"></span
			></strong>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="slotsCount">
		<mat-header-cell *matHeaderCellDef>Liczba osób</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index">
			<div class="d-flex justify-content-center align-items-center w-100">
				<ng-container
					*ngTemplateOutlet="
						stopConnectionInputTemp;
						context: {
							count: element.slotsCount.boarding,
							backgroundColor: StopKindColor.BOARDING,
							tooltipText: 'Wsiadający',
						}
					"
				></ng-container>

				<ng-container
					*ngTemplateOutlet="
						stopConnectionInputTemp;
						context: {
							count: element.slotsCount.dropOff,
							backgroundColor: StopKindColor.DROP_OFF,
							tooltipText: 'Wysiadający',
						}
					"
				></ng-container>
			</div>
			<ng-template
				#stopConnectionInputTemp
				let-count="count"
				let-backgroundColor="backgroundColor"
				let-tooltipText="tooltipText"
			>
				@if (count !== null) {
					<div
						class="rounded-circle d-flex justify-content-center align-items-center text-white fw-bold user-select-none shadow-sm mx-1 square-size"
						[ngStyle]="{ backgroundColor: backgroundColor }"
						[matTooltip]="tooltipText"
					>
						{{ count }}
					</div>
				}
			</ng-template>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="stopSale">
		<mat-header-cell *matHeaderCellDef>Stop Sale</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index">
			@if (
				element.action.toString() !== StopKind.CRUISING.toString() &&
				element.action.toString() !== StopKind.TARGET.toString()
			) {
				<mat-slide-toggle
					[ngModel]="element.stopSale"
					(ngModelChange)="emitStopSale($event, element.id, vehicleId())"
					color="primary"
				></mat-slide-toggle>
			}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="surcharge">
		<mat-header-cell *matHeaderCellDef>Dopłata</mat-header-cell>
		<mat-cell *matCellDef="let element">
			@if (element.action.toString() !== StopKind.TARGET.toString()) {
				<mat-form-field class="my-2">
					<mat-label>PLN</mat-label>
					<input
						[ngModel]="element.fee | price"
						(ngModelChange)="element.fee = $event * 100"
						appDetectValueChangeOnFocusOut
						(valueChangeOnFocusOut)="emitFee(element.fee, element.id, vehicleId())"
						matInput
						type="number"
					/>
				</mat-form-field>
			}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="flightNumber">
		<mat-header-cell *matHeaderCellDef>Nr lotu</mat-header-cell>
		<mat-cell *matCellDef="let element">
			@if (element.action.toString() !== StopKind.TARGET.toString()) {
				<mat-form-field class="my-2">
					<input
						[(ngModel)]="element.flightNumber"
						matInput
						appDetectValueChangeOnFocusOut
						(valueChangeOnFocusOut)="emitFlightNumber(element.flightNumber, element.id, vehicleId())"
					/>
				</mat-form-field>
			}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="airline">
		<mat-header-cell *matHeaderCellDef>Przewoźnik</mat-header-cell>
		<mat-cell *matCellDef="let element"> {{ element.airline }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="break">
		<mat-header-cell *matHeaderCellDef>Przerwa</mat-header-cell>
		<mat-cell *matCellDef="let element">
			@if (element.action.toString() !== StopKind.TARGET.toString()) {
				<mat-form-field class="my-2">
					<mat-label>min.</mat-label>
					<input
						matInput
						[(ngModel)]="element.pauseDuration"
						appDetectValueChangeOnFocusOut
						(valueChangeOnFocusOut)="emitPauseDuration(element.pauseDuration, element.id, vehicleId())"
						type="number"
					/>
				</mat-form-field>
			}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="departure">
		<mat-header-cell *matHeaderCellDef>Data odjazdu</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index">
			@if (timeDepartures()[i]) {
				<app-date-time-form
					class="w-100"
					[timeDeparture]="timeDepartures()[i]"
					(timeDepartureChange)="emitTimeDeparture($event, element.id, vehicleId())"
				>
				</app-date-time-form>
			}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="time">
		<mat-header-cell *matHeaderCellDef> Czas </mat-header-cell>
		<mat-cell class="position-relative overflow-visible" *matCellDef="let element; let i = index">
			@if (element.isNotLastRow && element.isNotBeforeFinalTargetRow && element?.action !== StopKind.TARGET) {
				<button
					(click)="showStopConnectionDetails(element.stopConnection, i)"
					class="position-absolute z-1 top-100 start-50 translate-middle"
					[color]="!!element.stopConnection ? 'primary' : 'warn'"
					mat-mini-fab
				>
					{{ !!element.stopConnection ? element.stopConnection.minutes : 'Brak' }}
				</button>
			}
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
	<mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
</mat-table>

@if (antennas().length) {
	<mat-accordion multi="true">
		@for (item of antennas(); track item.vehicle.id; let index = $index) {
			<mat-expansion-panel
				[expanded]="isExpandedPanelsArr()[index].expanded"
				(expandedChange)="
					expansionStateChange.emit({ expansionPanel: isExpandedPanelsArr()[index], valueToSet: $event })
				"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						@if (item.editableVehicle) {
							<mat-form-field>
								<mat-label>Wybierz pojazd</mat-label>
								<input
									(click)="emitFilterVehicleByName(item.vehicle); $event.stopPropagation()"
									(keydown.space)="$event.stopPropagation()"
									type="text"
									matInput
									[ngModel]="item.vehicle"
									(ngModelChange)="emitFilterVehicleByName($event)"
									[matAutocomplete]="auto"
								/>
								<mat-autocomplete
									(optionSelected)="
										emitChangeSelectedVehicle(item.vehicle, $event.option.value);
										item.editableVehicle = !item.editableVehicle
									"
									#auto="matAutocomplete"
									[displayWith]="displayFn"
								>
									@for (option of filteredOptions(); track option.id) {
										<mat-option [value]="option.id">{{ option.name }}</mat-option>
									}
								</mat-autocomplete>
							</mat-form-field>
						} @else {
							<strong class="d-flex justify-content-center align-items-center"
								><span>Pojazd: {{ item.vehicle.name }}</span>
								<button
									class="d-flex justify-content-center align-items-center fs-5 ms-1"
									mat-icon-button
									(click)="item.editableVehicle = !item.editableVehicle; $event.stopPropagation()"
								>
									<i class="fa-solid fa-pencil"></i></button
							></strong>
						}
					</mat-panel-title>
					<mat-panel-description>
						@if (item.vehicle.transportVehicleKind === TransportVehicleKind.ANTENNA) {
							<span>Antenka <i class="fas ms-2 fa-car"></i></span>
							<button
								color="primary"
								mat-raised-button
								[disabled]="antennasLoader()"
								class="ms-2"
								style="width: 235px"
								(click)="openTourismEventModal(item); $event.stopPropagation()"
							>
								@if (antennasLoader()) {
									<mat-spinner diameter="20"></mat-spinner>
								} @else {
									Utwórz wydarzenie antenkowe
								}
							</button>
						} @else if (item.vehicle.transportVehicleKind === TransportVehicleKind.BUS) {
							<span>Autokar <i class="fas ms-2 fa-bus"></i></span>
						}
					</mat-panel-description>
				</mat-expansion-panel-header>

				<ng-template matExpansionPanelContent>
					<app-transport-timetable-table
						[transportId]="transportId()"
						[timetables]="item.timetable"
						[vehicleId]="item.vehicle.id"
						[transportLogic]="item.transportLogic"
						[antennas]="item.antennasForVehicle"
						[timeDepartureMap]="timeDepartureMap()"
						[timeDepartures]="timeDepartureMap().get(item.vehicle.id)"
						[isExpandedPanelsArr]="isExpandedPanelsArr()[index].antennas"
						[transportKind]="transportKind()"
						[filteredOptions]="filteredOptions()"
						[side]="side()"
						(timeDepartureChange)="emitTimeDeparture($event.timeDeparture, $event.id, $event.vehicleId)"
						(stopConnectionChange)="emitStopConnection($event)"
						(stopSaleChange)="emitStopSale($event.stopSale, $event.timetableId, $event.vehicleId)"
						(feeChange)="emitFee($event.fee, $event.timetableId, $event.vehicleId)"
						(pauseDurationChange)="
							emitPauseDuration($event.pauseDuration, $event.timetableId, $event.vehicleId)
						"
						(expansionStateChange)="expansionStateChange.emit($event)"
						(filterVehiclesByNameChange)="emitFilterVehicleByName($event.value)"
						(changeSelectedVehicleChange)="
							emitChangeSelectedVehicle($event.currentVehicle, $event.vehicleIdToUpdate)
						"
					></app-transport-timetable-table>
				</ng-template>
			</mat-expansion-panel>
		}
	</mat-accordion>
}
